var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "transition",
    {
      attrs: { name: _vm.name },
      on: {
        "before-appear": _vm.beforeAppear,
        appear: _vm.appear,
        "after-appear": _vm.afterAppear,
        "appear-cancelled": _vm.appearCancelled,
        "before-enter": _vm.beforeEnter,
        enter: _vm.enter,
        "after-enter": _vm.afterEnter,
        "enter-cancelled": _vm.enterCancelled,
        "before-leave": _vm.beforeLeave,
        leave: _vm.leave,
        "after-leave": _vm.afterLeave,
        "leave-cancelled": _vm.leaveCancelled,
      },
    },
    [_vm._t("default")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }